import { CSVLink } from 'react-csv'

import type { BulkExportCultureMetadataResponse } from '~/api/backend/pages/bulkExportCultureMetadataAPI'
import Button from '~/components/buttons/Button'
import DownloadIcon from '~/components/icons/DownloadIcon'
import Textarea from '~/components/Textarea'
import { analytics } from '~/core/analytics'
import BulkExportCultureMetadataPreview from './BulkExportCultureMetadataPreview'
import cs from './bulk_export_culture_metadata.scss'
import { getCSVDataFromRows, getDataRows } from './getDataRows'
import { getMissingPlates } from './getMissingPlates'

interface BulkExportCultureMetadataContentsProps {
  plateBarcodesToFetch: string[]
  rawData: string
  setRawData: (rawData: string) => void
  parsedData: BulkExportCultureMetadataResponse | null
  isParsingData: boolean
}

const BulkExportCultureMetadataContents = ({
  plateBarcodesToFetch,
  rawData,
  setRawData,
  parsedData,
  isParsingData,
}: BulkExportCultureMetadataContentsProps) => {
  const renderExportButton = () => {
    if (
      plateBarcodesToFetch.length === 0 ||
      parsedData === null ||
      getMissingPlates(parsedData, plateBarcodesToFetch).length > 0
    ) {
      return (
        <Button
          className={cs.button}
          type='primary'
          label='Bulk Export (.csv)'
          onClick={() => {}}
          disabled
        />
      )
    }

    const csvData = getCSVDataFromRows(getDataRows(parsedData, plateBarcodesToFetch))
    return (
      <CSVLink
        data={csvData}
        enclosingCharacter=''
        filename='monomer_culture_metadata.csv'
        className={cs.link}
      >
        <Button
          className={cs.button}
          type='primary'
          label='Bulk Export (.csv)'
          onClick={() => {
            analytics.track('Completed Bulk Export Culture Metadata', {
              numCultures: csvData.length,
              numPlates: plateBarcodesToFetch.length,
            })
          }}
        />
      </CSVLink>
    )
  }

  return (
    <div className={cs.bulkExportCultureMetadata}>
      <div className={cs.header}>
        <DownloadIcon className={cs.headerIcon} />
        <div className={cs.headerText}>Bulk Export Culture Metadata</div>
        <div className={cs.fill} />
        <Button className={cs.cancelButton} label='Cancel' to='/cultures' />
        {renderExportButton()}
      </div>
      <div className={cs.body}>
        <div className={cs.inputColumn}>
          <div className={cs.sectionTitle}>Paste Plate Barcodes</div>
          <Textarea
            className={cs.textarea}
            value={rawData}
            rows={8}
            onChange={value => setRawData(value)}
            placeholder={'PLATE1\nPLATE2\nPLATE3'}
          />
        </div>
        <div className={cs.previewColumn}>
          <BulkExportCultureMetadataPreview
            className={cs.preview}
            loading={isParsingData}
            data={parsedData || undefined}
            plateBarcodesToDisplay={plateBarcodesToFetch}
          />
        </div>
      </div>
    </div>
  )
}

export default BulkExportCultureMetadataContents
